export default __webpack_public_path__ + "static/media/g3.75621c20.jpg";